import { render, staticRenderFns } from "./SipPasswordApartment.vue?vue&type=template&id=8f2bb60a&scoped=true"
import script from "./SipPasswordApartment.vue?vue&type=script&lang=js"
export * from "./SipPasswordApartment.vue?vue&type=script&lang=js"
import style0 from "./SipPasswordApartment.vue?vue&type=style&index=0&id=8f2bb60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2bb60a",
  null
  
)

export default component.exports